"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var pt_br_1 = require("@react-form-fields/core/lang/pt-br");
var pt_BR_1 = require("date-fns/locale/pt-BR");
var langPTBR = tslib_1.__assign({}, pt_br_1.default, { dateLocale: pt_BR_1.default, dateFormat: 'dd/MM/yyyy', timeFormat: 'HH:mm', dateTimeFormat: 'dd/MM/yyyy HH:mm', dateLabels: {
        cancel: 'Cancelar',
        ok: 'Ok',
        clear: 'Limpar'
    }, trumbowyg: {
        loadLocale: function () { return Promise.resolve().then(function () { return require('trumbowyg/dist/langs/pt_br.min.js'); }); },
        config: { lang: 'pt_br' }
    } });
exports.default = langPTBR;
//# sourceMappingURL=pt-br.js.map